import React from 'react'
import { Card, CardBody } from "reactstrap"
import { isEmpty, head } from 'lodash'
import CurrencyFormat from 'react-currency-format'
import { isMobile } from 'react-device-detect'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const Itemv2 = ({
  item,
  view,
  remove,
  showSetQuantity,
  onChangeQuantity,
}) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div style={{ display: 'flex' }}>
            <div className="product-item-remove" onClick={() => remove(item)}>
              <i className="mdi mdi-close font-size-24"></i>
            </div>
            <img
              src={
                !isEmpty(item.gallery) ?
                  head(item.gallery).fileName :
                  !isEmpty(item.product.gallery) ?
                    head(item.product.gallery).fileName : 
                    getUrlOfDefaultProductImage()
              }
              alt=""
              width="70px"
              height="100px"
              onClick={() => view(item)}
              className="cursor-pointer"
              style={{ marginRight: isMobile ? '5px' : '10px' }}
            />
            <div style={{ display: 'block' }}>
              <div className="cart-user-address-card-subtitle cursor-pointer" onClick={() => view(item)}>
                {item.name || item.product.name}
              </div>
              <div style={{ alignSelf: 'center', fontWeight: 300 }} onClick={() => view(item)}>
                {
                  !isEmpty(item.firstVariantSelected) && (
                    <span style={{ color: 'gray' }}>
                      Color: {`${item.firstVariantSelected} `}
                    </span>
                  )
                }
                {
                  !isEmpty(item.productVariant) &&
                  !isEmpty(item.productVariant.firstOption) &&
                  !isEmpty(item.productVariant.firstOption.value) && (
                    <span style={{ color: 'gray' }}>
                      {item.productVariant.firstOption.label}: {`${item.productVariant.firstOption.value} `}
                    </span>
                  )
                }
                {
                  !isEmpty(item.secondVariantSelected) && (
                    <span style={{ color: 'gray' }}>
                      - Talla: {`${item.secondVariantSelected} `}
                    </span>
                  )
                }
                {
                  !isEmpty(item.productVariant) &&
                  !isEmpty(item.productVariant.secondOption) &&
                  !isEmpty(item.productVariant.secondOption.value) && (
                    <span style={{ color: 'gray' }}>
                      - {item.productVariant.secondOption.label}: {`${item.productVariant.secondOption.value} `}
                    </span>
                  )
                }
                {
                  !isEmpty(item.thridVariantSelected) && (
                    <span style={{ color: 'gray' }}>
                      - Presentación: {item.thridVariantSelected}
                    </span>
                  )
                }
                {
                  !isEmpty(item.productVariant) &&
                  !isEmpty(item.productVariant.thirdOption) &&
                  !isEmpty(item.productVariant.thirdOption.value) && (
                    <span style={{ color: 'gray' }}>
                      - {item.productVariant.thirdOption.label}: {item.productVariant.thirdOption.value}
                    </span>
                  )
                }
              </div>
              <label
                onClick={() => view(item)}
                style={{ fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}
              >
                <CurrencyFormat
                  value={!isEmpty(item.wholeSalePrice) ? Math.round(item.wholeSalePrice) : Math.round(item.product.wholeSalePrice)}
                  displayType="text"
                  thousandSeparator
                  decimalScale={2}
                  prefix="$"
                />
              </label>
              {showSetQuantity && (
                <div className="cart-user-address-card-subtitle" style={{ display: 'flex' }}>
                  <div style={{ marginTop: '3px' }}>
                    Cant.
                  </div>
                  <div>
                    <button
                      className="btn-secondary"
                      onClick={() => { onChangeQuantity(item, item.quantity - 1) }}
                      disabled={item.quantity === 1}
                      style={{ marginLeft: '10px' }}
                    >
                      <i className="mdi mdi-minus"></i>
                    </button>
                  </div>
                  <div>
                    <input
                      type="text"
                      name={`quantity-${item.id}`}
                      id={`quantity-${item.id}`}
                      style={{ width: '80px', textAlign: 'center' }}
                      value={item.quantity}
                      placeholder="Cantidad"
                      maxLength={3}
                      onChange={(event) => {
                        onChangeQuantity(item, event.target.value)
                      }}
                    />
                  </div>
                  <div>
                    <button
                      className="btn-secondary"
                      onClick={() => { onChangeQuantity(item, parseInt(item.quantity) + 1) }}
                    >
                      <i className="mdi mdi-plus"></i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default Itemv2
